import { FC, memo } from 'react'
import { Text, Flex, IconButton } from '@chakra-ui/react'

import { ArrowRight } from 'components/icons'

type Props = {
  year: number
  stringMonth: string
  onClick: () => void
}

const EndCalendarHeader: FC<Props> = ({ year, stringMonth, onClick }) => {
  return (
    <Flex justify="space-between" align="center">
      <Text color="primary" fontSize="md" marginLeft="50px">
        {stringMonth} de {year}
      </Text>

      <IconButton
        size="xs"
        variant="ghost"
        rounded="full"
        aria-label="Ir para o mês anterior"
        icon={<ArrowRight />}
        onClick={onClick}
        _hover={{ bg: 'primary', color: 'light' }}
      />
    </Flex>
  )
}

export default memo(EndCalendarHeader)
